<template>
  <div>
    <!-- Hero -->
    <section class="hero" :style="{ '--hero-img': `url(${heroImage})` }">
      <div class="wrap hero-inner">
        <p class="eyebrow reveal">Interior Design Studio · Singapore</p>
        <h1 class="reveal">A space that is <em>crafted</em>, not just constructed.</h1>
        <!-- <p class="reveal">
          From a first BTO to a home you've lived in for years, we design interiors rooted in
          warmth, natural materials and quiet intention, shaped around the way you actually live.
        </p>  -->
        <div class="hero-actions reveal">
          <router-link to="/projects" class="btn btn-primary">View our work</router-link>
          <!-- <router-link to="/contact" class="btn btn-ghost">Start a project</router-link> -->
        </div>
      </div>
      <div class="scroll-hint"><span></span>Scroll</div>
    </section>

    <!-- How people come to us -->
    <section class="section tint">
      <div class="wrap">
        <div class="section-head reveal">
          <p class="eyebrow">How we're introduced</p>
          <h2>Often, through someone we've worked with</h2>
        </div>
        <p class="sit-lede reveal">
          EIKA is usually introduced through people we've worked with — homeowners, friends and
          trusted businesses who value the approach to design. Most come to us in one of the
          following situations:
        </p>
        <div class="sit-list">
          <div v-for="(sit, i) in situations" :key="sit" class="sit-item reveal">
            <span>{{ String(i + 1).padStart(2, "0") }}</span>
            <p>{{ sit }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Services preview -->
    <section class="section tint">
      <div class="wrap">
        <div class="section-head reveal">
          <p class="eyebrow">What we do</p>
          <h2>Designed for life</h2>
          <p>A complete home journey — from discovery to everyday living.</p>
        </div>
        <div class="cards cards-4">
          <div v-for="(s, i) in services" :key="s.title" class="card reveal">
            <span class="card-num">{{ String(i + 1).padStart(2, "0") }}</span>
            <h3>{{ s.title }}</h3>
            <p>{{ s.blurb }}</p>
          </div>
        </div>
        <div style="text-align: center; margin-top: 3rem" class="reveal">
          <router-link to="/services" class="btn btn-dark">Explore services</router-link>
        </div>
      </div>
    </section>


    <!-- Quote band -->
    <section class="band" :style="{ '--band-img': `url(${images.kitchenArchTerracotta})` }">
      <div class="wrap reveal">
        <blockquote>Let's craft your way of living.</blockquote>
        <cite>EIKA Interiors</cite>
      </div>
    </section>

    <!-- Google reviews -->
    <!-- <GoogleReviews /> -->

    <!-- Contact CTA -->
    <section class="section tint">
      <div class="wrap" style="text-align: center">
        <div class="reveal">
          <p class="eyebrow">Ready when you are</p>
          <h2 style="font-size: clamp(2rem, 4vw, 3.2rem); margin: 1rem 0 1.4rem">Let's craft yours, next.</h2>
          <p style="color: var(--muted); max-width: 46ch; margin: 0 auto 2rem">
            Share your vision with us, and let's explore how a space can be shaped around the way you actually live
          </p>
          <router-link to="/contact" class="btn btn-primary">Get in touch</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import GoogleReviews from "@/components/GoogleReviews.vue";
import { heroImage, images } from "@/data/projects";

export default {
  name: "HomeView",
  // components: { GoogleReviews },
  data() {
    return {
      heroImage,
      images,
      services: [
        { title: "Discover", blurb: "Understanding your lifestyle, aspirations, and how you want your home to support the way you live." },
        { title: "Design", blurb: "Transforming ideas into thoughtful spaces through planning, material curation, and detailed design." },
        { title: "Deliver", blurb: "Coordinating the renovation journey with careful project management, craftsmanship, and quality oversight." },
        { title: "Live", blurb: "Supporting you beyond completion with practical guidance, documentation, and continued care." },
      ],
      // The situations clients tend to be in when they first get in touch.
      situations: [
        "Starting a home or business from scratch",
        "Making sense of an existing space",
        "Refining an unfinished idea",
        "Managing the renovation from design to completion",
        "Making confident decisions about materials, details and budget",
      ],
    };
  },
};
</script>
